import { Box, FlexProps, Grid } from '@chakra-ui/react'
import { getRadioIcon } from '../../../../components/RadioIcon'

export interface OfferHeaderColumnWrapperProps extends FlexProps {
  isScrolled?: boolean
  icon?: string
}

export const OfferHeaderColumnWrapper = ({
  children,
  isScrolled,
  sx,
  icon,
  ...rest
}: OfferHeaderColumnWrapperProps) => {
  //const icon = 'householdProperty'
  const iconSize = '12'

  return (
    <Grid
      sx={{
        position: 'sticky',
        left: 0,
        alignItems: 'end',
        alignContent: 'stretch',
        bg: 'gray.50',
        boxShadow: isScrolled ? 'xl' : 'none',
        zIndex: 100,
        _after: {
          w: '1px',
          h: '100%',
          content: "''",
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '100%',
          bgColor: 'gray.300',
        },
      }}
      {...rest}
    >
      <Box
        sx={{
          display: 'grid',
          pb: 8,
          justifyContent: 'center',
          alignContent: 'end',
          alignItems: 'end',
          height: '100%',
          width: '100%',
          bg: 'gray.50',
          zIndex: 100,
        }}
      >
        <Box sx={{ mt: 3, ml: -1 }}>
          {icon && getRadioIcon({ colorScheme: 'primary', icon, defaultIconSize: iconSize })}
        </Box>
      </Box>

      {children}
    </Grid>
  )
}
